import { gql } from '@apollo/client';

export const coinMarketCapFragment = gql`
  fragment coinMarketCapFields on AssetCmcInfoPayload {
    circulatingSupply
    cmcRating
    code
    dateAdded
    fdv
    marketCap
    maxPrice
    maxPrice1m
    maxPrice1mDate
    maxPrice1y
    maxPrice1yDate
    maxPrice24h
    maxPrice24hDate
    maxPriceDate
    maxSupply
    minPrice
    minPrice1m
    minPrice1mDate
    minPrice1y
    minPrice1yDate
    minPrice24h
    minPrice24hDate
    minPriceDate
    price
    rate
    totalSupply
    volmktcap24h
    volume24h
    volumeChange24h
    marketCapChange
  }
`;
